import React from 'react'
import { CircularProgress } from '@material-ui/core'
import './Loader.css'

const TransparentLoader = () => {
    return (
        <div className="custom-loader-trans-container">
            <CircularProgress color="success" />
        </div>
    )
}

export default TransparentLoader
